// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f08fcd98","732":"d789bc50"}[chunkId] + ".chunk.js";
};